<template>
  <div>
    <loading :active="isLoading" :can-cancel="false" :is-full-page="true" />
    <v-snackbar v-model="snackbar" :multi-line="true" :timeout="6000" :location="'top'" :vertical="false">
      {{ snackbarText }}
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false">Close</v-btn>         
      </template>
    </v-snackbar>
    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Error</span>
        </v-card-title>
        <!-- <v-card-text v-html="dialogText">

        </v-card-text> -->
        <v-card-actions>
          <v-spacer />
          <v-btn color="green-darken-1" variant="text" @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card prepend-icon="mdi-cog" style="padding-right: 0px;">
      <template v-slot:title>
        <h3 class="text-black">Settings</h3>
      </template>
    </v-card>


    <v-divider />
    <v-layout v-if="expanded == 1" row>
      <v-col col="12" style="padding: 0px;">
        <v-card>
          <v-card-title class="padding_bottom_0">
            <h3 class="text-black">Date Range</h3>
          </v-card-title>
          <v-card-text class="padding_bottom_0">
            <!-- <p class="text-lg-left">
                Auto approve will skip the pending queue and will automatically approve the transactions.
                Select user(s) for which you would like auto approval.
              </p> -->
            <span class="position_right">
              <v-btn color="success" @click="saveUsers()">Save</v-btn>
            </span>
          </v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Item Category" single-line
                hide-details variant="underlined" color="primary" />
            </v-card-title>
            <v-data-table :headers="header" :items="users" :items-per-page="10" class="elevation-1" :search="search"
              :no-results-text="`Your search for ${search} found no results.`"
              no-data-text="Sorry, nothing to display here." ref="datatable">

              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-left hidden-xs">
                    {{ item.Name }}
                  </td>
                  <td class="text-left hidden-xs">
                    {{ item.ValueObject.Type }}
                  </td>
                  <td class="text-left hidden-xs">

                    {{ item.ValueObject.Description }}
                  </td>
                  <td class="text-left hidden-xs">
                    <VueDatePicker v-model="item.ValueObject.BeginingDate" placeholder="mm/dd/yyyy"
                      :enable-time-picker="false" />
                  </td>
                  <td class="text-left hidden-xs">
                    <VueDatePicker v-model="item.ValueObject.EndingDate" placeholder="mm/dd/yyyy"
                      :enable-time-picker="false" />
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>

          <br>
        </v-card>
      </v-col>
    </v-layout>

  </div>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */

import DataService from '@/services/data-service';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {
  AppSettingConfigurations
} from "../constants/index"
import { ref, reactive, toRefs, isProxy, toRaw, unref } from 'vue';
import Helpers from '@/services/helpers';
const Helper = new Helpers();

const dataService = new DataService();
const CurrentAppSettings = AppSettingConfigurations.ProductCategoryDateRange;

class AppSettings {
  constructor(_id = "", _type = CurrentAppSettings, _name = "", _value = "", _valueObject = new ProductCategory()) {
    this.Type = _type;
    this.Name = _name;
    this.Value = _value;
    this.ValueObject = _valueObject;
    this.Description = _valueObject.Description;
    this.BeginingDate = this.ValueObject.BeginingDate;
    this.EndingDate = this.ValueObject.EndingDate;
    this.Type = this.ValueObject.Type;
    this.Id = _id;
  }
  Id;
  Name;
  Value;
  ValueObject;
  Description;
  BeginingDate;
  EndingDate;
  Type;
}

class ProductCategory {
  constructor(_type = "", _description = "", _beginingDate = "", _endingDate = "") {
    this.Type = _type;
    this.Description = _description;
    this.BeginingDate = _beginingDate;
    this.EndingDate = _endingDate;
  }
  Type;
  Description;
  BeginingDate;
  EndingDate;
}
export default {
  name: 'settings',
  data: () => ({
    snackbar: false,
    expanded: 0,
    snackbarText: '',
    search: '',
    searchText: '',
    snackbarTextList: [],
    searchUsers: [],
    users: [],
    test: [],
    isLoading: false,
    endMenu: false,
    startMenu: false,
    dialog: false,
    dialogText: '',
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    sortBy: [{ key: 'Description', order: 'asc' }],
    // refreshTime: '',
    pickDate: false,
    useOnFocus: true,
    showPicker: false,
    selectedDate: null,
    header: [
      { title: 'Code', value: 'Name', key: 'Name', width: "10%" },
      { title: 'Category Type', value: 'Type', key: 'Type', width: "10%" },
      { title: 'Description', value: 'Description', key: 'Description', width: "25%" },
      { title: 'Begining Date', value: 'BeginingDate', key: 'BeginingDate', sortable: false, width: "20%" },
      { title: 'Ending Date', value: 'EndingDate', key: 'EndingDate', sortable: false, width: "20%" }
    ],



  }),
  created() {
    this.initilize();
  },
  components: {
    Loading,

  },
  methods: {
    async initilize() {
      this.isLoading = true;
      this.expanded = 1;
      await this.GetAppSettings();
      await this.GetProductCategoryFromAgris();
      this.isLoading = false;
    },
    onFocus() {
      if (this.useOnFocus) {
        this.pickDate = true
      }
    },
    onBlur() {
      if (this.useOnFocus) {
        this.pickDate = false
      }
    },
    validateDates() {
      var endDateYear = new Date(Date.now()).getFullYear();
      var endDateMonth = new Date(Date.now()).getMonth();
      var endDateDate = new Date(Date.now()).getDate();
      var currentDate = new Date(endDateYear, endDateMonth, endDateDate);
      var errorMessageArray = [];
      for (var i = 0; i < this.users.length; i++) {
        let hasError = false;
        let currentObj = this.users[i];
        let errorMessage = `=> Code: ${currentObj.Name}`;
        let currentObjBegDate = new Date(currentObj.ValueObject.BeginingDate);
        let currentObjEndDate = new Date(currentObj.ValueObject.EndingDate);
        //  if(currentObjBegDate < currentDate)
        //  {
        //     // errorMessage = `${errorMessage} Begining Date cannot be before the Current date`;
        //     hasError = true;          
        //  }
        //  if(currentObjEndDate < currentDate)
        //  {
        //   // errorMessage = `${errorMessage} Ending Date cannot be before the Current date`
        //   hasError = true; 
        //  }
        if (currentObjEndDate <= currentObjBegDate) {
          // errorMessage = `${errorMessage} Ending Date cannot be bfore the Begining date`
          hasError = true;
        }
        if (hasError)
          errorMessageArray.push(errorMessage);
      }
      if (errorMessageArray.length > 0) {
        this.dialog = true;
        this.dialogText = `Following items have invalid dates:<br/> ${errorMessageArray.join('<br/>')}`;
        //this.snackbarText = `Following items have invalid dates:<br/> ${errorMessageArray.join('<br/>')}`;
        //this.snackbarText = "Following items have invalid dates: ";
        //this.snackbarTextList = errorMessageArray;
        return false;
      }
      return true;
    },
    saveUsers() {
      if (this.validateDates()) {
        this.users.forEach((user) => {
          user.Type = CurrentAppSettings;
        });
        this.users.forEach(u => u.Value = JSON.stringify(u.ValueObject));
        dataService
          .SaveAppSettings(this.users)
          .then((response) => {
            this.snackbar = true;
            this.snackbarText = 'Settings saved successfully';
            this.users.splice(0);
            this.initilize();
          })
          .catch((e) => {
            this.snackbar = true;
            this.snackbarText = 'Settings saved failed';
          });
      }
    },
    // search() {
    //   this.searchUsers = Object.assign([], this.users);
    //   this.searchUsers = this.searchUsers.filter((user) => {
    //     const srch = this.searchText;
    //     return (
    //       user.Name.toLowerCase().indexOf(srch.toLowerCase()) !==
    //         -1 ||
    //       user.ValueObject.Description.toLowerCase().indexOf(srch.toLowerCase()) !== -1
    //     );
    //   });
    // },

    async GetProductCategoryFromAgris() {
      try {
        var response = await dataService.GetProductCategoryFromAgris();
        if (response && response.length) {
          response.forEach(resp => {
            let productCategory = new ProductCategory();
            productCategory.Type = resp.CategoryTypeDV;
            productCategory.Description = resp.Description;
            let appSetting = new AppSettings("", CurrentAppSettings, resp.Code, "", productCategory);
            let existingAppSetting = this.users.find(u => u.Name == appSetting.Name)
            if (existingAppSetting) {
              existingAppSetting.ValueObject.Type = productCategory.Type;
              existingAppSetting.ValueObject.Description = productCategory.Description;
            }
            else {
              this.users.push(appSetting);
            }
          });
          this.users = this.users.filter(ar => response.find(rm => (rm.Code == ar.Name)))

          if (isProxy(this.users)) {
            var rawData = Helper.toDeepRaw(this.users);
            console.log(rawData);
            this.test.push(unref(rawData));
            console.log(this.test);
          }
          this.searchUsers = Object.assign([], this.users);
        }
      } catch (ex) {
        console.log(ex);
        this.snackbar = true;
        this.snackbarText = "Failed to fetch product category list from AGRIS";
      }
    },
    async GetAppSettings() {
      try {
        let response = await dataService.GetAppSettingsByType(
          CurrentAppSettings
        );

        if (response && response.length) {
          for (var i = 0; i < response.length; i++) {
            let valueObject = JSON.parse(response[i].Value);
            let appSetting = new AppSettings(response[i].Id, CurrentAppSettings, response[i].Name, "", valueObject);
            this.users.push(appSetting);
          }
          this.searchUsers = Object.assign([], this.users);

          console.log(this.users);
        }
      } catch (ex) {
        console.log(ex);
        this.isLoading = false;
        this.snackbar = true;
        this.snackbarText = "Failed to fetch saved settings";
      }
    },
    formatDate(value, dateFormat = "MM/DD/YYYY") {
      if (value) {
        return moment(String(value)).format(dateFormat);
      }
    },
    // customSearch (value, search, item) {      
    //       return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search))
    //   }
  },
};
</script>

<style>
.padding_left_20 {
  padding-left: 12px;
}

.padding_10 {
  padding: 10px;
}

.v-list {
  height: 400px;
  overflow-y: auto;
}

.text_right {
  text-align: right;
}

.position_right {
  right: 125px;
  position: absolute;
  top: 3px;
}

.v-expansion-panel__header {
  background-color: white;
}

.swtich {
  position: absolute;
  top: -8px;
  right: 57px;
  z-index: 1000;
}

.padding_bottom_0 {
  padding-bottom: 0px;
}
</style>
